import React from 'react';

import './RadioOptions.css';
import withErrorHandler from '../../../components/ErrorHandler';

const RadioOptions = (props) => {
    const {
      label,
      fieldName,
      value,
      onChange,
    } = props;

    return (
      <div id={fieldName} className='a-radio-button' onClick={onChange}>
        <input type="radio" checked={value} onChange={onChange} />
        <label>{label}</label>
      </div>
    );
  };

export default withErrorHandler(React.memo(RadioOptions));